"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdSpinner = _interopRequireDefault(require("cccisd-spinner"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement(_cccisdSpinner["default"], {
    options: {
      lines: 13,
      // The number of lines to draw
      length: 24,
      // The length of each line
      width: 12,
      // The line thickness
      radius: 26,
      // The radius of the inner circle
      scale: 1,
      // Scales overall size of the spinner
      corners: 1,
      // Corner roundness (0..1)
      color: '#333',
      // #rgb or #rrggbb or array of colors
      opacity: 0.25,
      // Opacity of the lines
      rotate: 0,
      // The rotation offset
      direction: 1,
      // 1: clockwise, -1: counterclockwise
      speed: 1,
      // Rounds per second
      trail: 60,
      // Afterglow percentage
      fps: 20,
      // Frames per second when using setTimeout() as a fallback for CSS
      zIndex: 2e9,
      // The z-index (defaults to 2000000000)
      className: 'spinner',
      // The CSS class to assign to the spinner
      top: '50%',
      // Top position relative to parent
      left: '50%',
      // Left position relative to parent
      shadow: false,
      // Whether to render a shadow
      hwaccel: false,
      // Whether to use hardware acceleration
      position: 'absolute' // Element positioning
    }
  }));
};